export function camelize(text: string) {
  return text
    .replaceAll('_', ' ')
    .split(' ')
    .map((e) => e[0].toLocaleUpperCase() + e.slice(1))
    .join(' ');
}
export const DEFAULT_COMMISSION_RULE = {
  bonus_cash: {
    group: {
      min_sale: 25000,
      tier: [
        {
          cash_bonus: 6500,
          min_sale: 100000,
        },
        {
          cash_bonus: 3000,
          min_sale: 50000,
        },
        {
          cash_bonus: 1200,
          min_sale: 25000,
        },
      ],
    },
    individual: {
      min_sale: 3500,
      tier: [
        {
          cash_bonus: 1000,
          min_sale: 20000,
        },
        {
          cash_bonus: 800,
          min_sale: 10000,
        },
        {
          cash_bonus: 500,
          min_sale: 7000,
        },
        {
          cash_bonus: 200,
          min_sale: 3500,
        },
      ],
    },
  },
  sales_commission: {
    srikandi: [
      {
        commission: 0.05,
        min_sale: 1500,
      },
      {
        commission: 0.03,
        min_sale: 0,
      },
    ],
    srikandi_emas: [
      {
        commission: 0.07,
        min_sale: 3000,
      },
      {
        commission: 0.05,
        min_sale: 1500,
      },
      {
        commission: 0.03,
        min_sale: 0,
      },
    ],
  },
  target_sale: {
    commission: 0.02,
    min_children: 5,
    srikandi: 1500,
    srikandi_emas: 3000,
  },
  override: [],
};

export const DEFAULT_PRODUCT_COMBO = {
  comboname: '',
  items: [],
};